module.exports = __webpack_public_path__ + "static/media/Twitter.2890bac9.png";